import Core from 'managers/core';

export default class PermissionsManager {
    constructor(api) {
        this.api = api;
    }

    getPermissions = () =>
        new Promise((resolve, reject) => {
            this.api.getPermissions().then(
                (res) => {
                    if (res !== undefined && Object.keys(res).length > 0) {
                        Core.cacheManager.setPermissionsStore(res);
                        resolve(res);
                    } else {
                        reject();
                    }
                },
                (error) => reject(error),
            );
        });

    changeScope = (scope) =>
        this.api.changeScope(scope).then((response) => {
            if (response && response.token !== undefined && response.token.length > 0) {
                const { token } = response;
                return token;
            }
            return null;
        });
}
